/*
 * Public API Surface of @mmscan/angular-ui/skeleton
 */

export * from './skeleton';
